import React, {Component} from 'react';
import {isEmpty} from '../../../utils/helpers';

import SummaryContainer from './SummaryContainer';
import ProductsPlan from './ProductsPlan';
import Loader from "../../../components/common/Spinners/Loader";
import {Form} from "formik";

class Products extends Component {
    state = {
        activeChange: false
    }

    valueUpdated = () => {
        this.setState({activeChange: true})
    }

    hasRealChanges = (currentFeatures, initialFeatures) => {
        if (currentFeatures.length !== initialFeatures.length) {
            return true;
        }
        const currentSet = new Set();
        const initialSet = new Set();

        currentFeatures.forEach(feature => {
            if (feature.featurePackageId) {
                currentSet.add(`package_${feature.featurePackageId}_${feature.featurePackageOptionId}`);
            } else if (feature.id) {
                currentSet.add(`feature_${feature.id}`);
            }
        });

        initialFeatures.forEach(feature => {
            if (feature.featurePackageId) {
                initialSet.add(`package_${feature.featurePackageId}_${feature.featurePackageOptionId}`);
            } else if (feature.id) {
                initialSet.add(`feature_${feature.id}`);
            }
        });

        if (currentSet.size !== initialSet.size) {
            return true;
        }

        for (let item of currentSet) {
            if (!initialSet.has(item)) {
                return true;
            }
        }

        return false;
    }

    render() {
        const {
            planName,
            plansDetails,
            values,
            setFieldValue,
            myServiceInfoItem,
            showHideManagePlan,
            updateChangeServiceLoading,
            isSubmitting,
            initialValues
        } = this.props;

        if (isEmpty(plansDetails)) {
            return <Loader/>;
        }

        return (
            <div className="card-product">

                <div className="card-body">
                    <ProductsPlan planName={planName} planInfo={plansDetails} values={values} setFieldValue={(field, value) => {
                        setFieldValue(field, value);
                        this.valueUpdated();
                    }}/>
                    <SummaryContainer
                        values={values}
                    />
                </div>

                <div className="card-footer">
                    <button className="btn btn-quick" onClick={showHideManagePlan}>Cancel</button>
                    <button
                        type="submit"
                        className="btn btn-primary"
                        data-target="manage-plan-success"
                        disabled={!this.state.activeChange || !this.hasRealChanges(values.features, initialValues.features) || updateChangeServiceLoading || isSubmitting}
                    >
                        Apply Changes
                    </button>
                </div>

            </div>
        );
    }
}

export default Products;
